import { memo } from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import About from '@/components/About';
import Reviews from '@/components/Reviews';
import Pricing from '@/components/Pricing';
import Contact from '@/components/Contact';
import FAQ from '@/components/FAQ';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const Index = memo(() => {
  return (
    <>
      <SEO includeFAQ />
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <About />
          <Reviews />
          <Pricing />
          <Contact />
          <FAQ />
        </main>
        <Footer />
      </div>
    </>
  );
});

Index.displayName = 'Index';

export default Index;
